import React, { Component } from "react";
import styled from "styled-components";
import * as translateTo from "../../utils/prism";

const PreStyled = styled.pre`
  display: flex;
  justify-content: center;
  margin-bottom: ${props => props.theme.margins.md};
`;

const StyledCode = styled.code`
  color: ${props => props.theme.colors.blue};
  font-family: ${props => props.theme.fontFamily.code};
  font-weight: ${props => props.theme.weights.thin};
  font-size: ${props => props.theme.fontSizes.code};
  background: ${props => props.theme.colors.primaryDark};
  padding: ${props => props.theme.margins.md};
  line-height: 1.4;
  overflow: scroll;
  width: 100%;
  max-width: 700px;
`;
/**
 *  Displays the formatted and highlighted CodeBlock
 * @prop {String} code - code literal
 * @prop {String} language - accepts: "javascript", "jsx", "html", "css"
 */
class CodeBlock extends Component {
  /** Return formatted code for a given languages
   * @param {String} code - code literal
   * @return HTML ready to render using dangerouslySetInnerHTML={{__html: HTML}}
   */
  getJsFormattedCode = code => translateTo.prismJs(code);
  getJsxFormattedCode = code => translateTo.prismJsx(code);
  getHtmlFormattedCode = code => translateTo.prismHtml(code);
  getCssFormattedCode = code => translateTo.prismCss(code);

  /**
   * Returns HTML code block ready to style with prismStyles.css
   *
   * @param {String} code - code literal
   * @param {String} language - accepts: "javascript", "jsx", "html", "css"
   * @return HTML ready to render using dangerouslySetInnerHTML={{__html: HTML}}
   */
  getFormattedCode = (code, language) => {
    switch (language) {
      case "javascript":
        return this.getJsFormattedCode(code);
      case "jsx":
        return this.getJsFormattedCode(code);
      case "css":
        return this.getCssFormattedCode(code);
      default:
        return this.getHtmlFormattedCode(code);
    }
  };

  render() {
    const { code, language } = this.props;
    return (
      <PreStyled>
        <StyledCode
          className={this.props.language}
          dangerouslySetInnerHTML={{
            __html: this.getFormattedCode(code, language)
          }}
        />
      </PreStyled>
    );
  }
}

export default CodeBlock;



// WEBPACK FOOTER //
// ./src/book/blocks/CodeBlock.js